import React, { Component } from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import { browserHistory } from 'react-router'

import resetPassword from 'controllers/user/resetPassword'
import loginAsUser from 'controllers/user/loginAsUser'
import "./Modal.scss";
import isEmpty from 'lodash/isEmpty';

class ModalBody extends Component {

  constructor(props){
    super(props);
    this.validateInputs = this.validateInputs.bind(this);
    this.state = {
      formData: {},
      errorMessage: ''
    }
  }

  resetPassword(){
    let {phone, pin, new_password} = this.state.formData
    let {dismiss} = this.props
    let newPhone = phone.country_code.trim() + phone.national_number.trim();
    resetPassword({phone: newPhone, pin: pin, new_password: new_password})
    .then((res) => {
      if(res.result === 'success'){
        this.setState({errorMessage: ''})
        loginAsUser({username: newPhone, password: new_password})
        .then((res) => {
          localStorage.setItem('token', res.data.user_token)
          dismiss()
          alert.success(__('Password Updated', 'settings')).then(() => {
            browserHistory.push('/')
            window.location.reload()
          })
        })
      }else {
        this.setState({errorMessage: res.reason})
      }

    })
  }
  validateInputs() {
    const { formData } = this.state;
    if(isEmpty(formData) || formData.new_password.length<6 || (formData.phone.national_number + formData.phone.country_code).length<6 || formData.pin.length!==4){
      return true;
    }
    return false;
  }
	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		return (
			<Modal
				className='forgot-password-modal'
				hasHeader={true}
        hasFooter={true}
				headerTitle={__('Forgot Password', 'appwrapper')}
				headerIcon="fa icon-tablet"
        fixedWidth={500}
        contentHeight={300}
        onCloseModalClick={dismiss}
        footerType="grey"
        footerButtons={[
          {
            title: __('Complete', 'appwrapper'),
            className: 'btn btn-primary pull-right',
            onClick: ()=>{
              this.resetPassword()
            },
						isDisabled: this.validateInputs,
          },
        ]}
        isShowingModal={show} >
        <ModalContent
          onFormChange={(stateFromModalContent)=>{ this.setState({formData: stateFromModalContent.params})}}
          errorMessage={this.state.errorMessage}
        />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/ForgotPassword/ModalBody.js